module.exports = __webpack_public_path__ + "img/map_contact.9166d339.png";